import { Position } from '@nucleus/types/web';
import React from 'react';
import styled, { css } from 'styled-components';
import { BlockLayout, blockLayoutInnerProps } from '../../blockLayouts/Base';
import { BlockPost } from '../../blocks/BlockPost';
import { SpacerTop } from '../../sectionLayouts/Spacers';
import { BlockLayoutProps } from '../../types/component';
import { PostBlockLayoutProps, getPositionRow } from './PostLayout';

export const PostBlockLayoutContentOnly = (props: PostBlockLayoutProps): JSX.Element => {
  const innerProps = blockLayoutInnerProps(props);

  const row = getPositionRow(props.blockInfoPosition);

  return (
    <StyledBlockLayout {...props} row={row}>
      <SpacerTop />
      <StyledContainer>
        <StyledBlockPost {...innerProps} block={props.blocks[0]} />
        <StyledSpacerBottom />
      </StyledContainer>
    </StyledBlockLayout>
  );
};

const PostHeightMap = {
  small: 1,
  medium: 2,
  large: 3,
};

const getPostPadding = (props: BlockLayoutProps) => {
  const defaultHeight = 'small';
  const multiplier = PostHeightMap[props.height ?? defaultHeight];

  return css`
    padding: calc(var(--unit-length) * ${multiplier}) var(--unit-length);
  `;
};

const StyledBlockPost = styled(BlockPost)``;

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  flex: 1 1 auto;
`;

const StyledSpacerBottom = styled(SpacerTop)``;

const StyledBlockLayout = styled(BlockLayout)<{
  row: Position;
}>`
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;

  ${StyledContainer} {
    justify-content: ${(props) => {
      switch (props.row) {
        case Position.Top:
          return 'flex-start';
        case Position.Center:
          return 'center';
        case Position.Bottom:
          return 'flex-end';
        default:
          return;
      }
    }};
  }

  ${StyledBlockPost} {
    ${getPostPadding}
  }
`;
